import { evidenceTypes } from '@/mocks/cases';
import SectionHeading from './SectionHeading';

const rules = [
  { icon: 'ri-fingerprint-line', text: '标注材料来源与提交时间，可追溯的优先展示' },
  { icon: 'ri-scissors-cut-line', text: '证件号、手机号、银行账号等隐私信息统一遮挡' },
  { icon: 'ri-refresh-line', text: '当事方回应后同步更新状态，不撤下原文' },
];

export default function EvidenceSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Evidence First"
          title="四类原始材料，逐项对照"
          desc="我们不接受只有文字描述的爆料。每条内容至少要附带一种可核对形式的材料，并在页面中标注关键时间点。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
            {evidenceTypes.map((type) => (
              <div key={type.key} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${type.icon} text-2xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{type.name}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{type.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-100 p-5 lg:col-span-4">
            <h3 className="font-heading text-base font-semibold text-foreground-950">材料展示规范</h3>
            <ul className="mt-4 space-y-4">
              {rules.map((rule) => (
                <li key={rule.text} className="flex gap-3 text-sm leading-relaxed text-foreground-700">
                  <i className={`${rule.icon} mt-0.5 text-primary-600`}></i>
                  {rule.text}
                </li>
              ))}
            </ul>
            <p className="mt-5 border-t border-background-300 pt-4 text-xs leading-relaxed text-foreground-500">
              提示：部分材料因涉及隐私或正在核实，页面仅展示摘要信息，完整材料需通过投稿邮箱申请对接。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}